import { IPunchAssignmentsItemDTO } from 'src/api/dtos';
import http from 'src/api/http';
import ESSRepository from 'src/api/repositories/ess/ess.repository';
import { IListQueryResult } from 'src/api/types';

export default class PunchAssignmentRepository extends ESSRepository {
  private static readonly baseRoute = '/punchassignments';
  private static readonly apiURL = PunchAssignmentRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public get = async (): Promise<IPunchAssignmentsItemDTO[]> => {
    try {
      const { data } = await http.get<IListQueryResult<IPunchAssignmentsItemDTO>>(PunchAssignmentRepository.apiURL);
      return data.items;
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
